import React from 'react';
import { AppI18n } from '../../i18n';
import { TriggerScenario } from './types';

export interface BriefFloatingFormPopupProps {
  triggerScenario?: TriggerScenario;
  profession: string;
}

export const BffPopupTtile = ({
  triggerScenario,
  profession,
}: React.PropsWithChildren<BriefFloatingFormPopupProps>) => {
  switch (triggerScenario) {
    case TriggerScenario.FIRST_TIME: {
      return <AppI18n k="brief_floating_form.popup.title.first_time" />;
    }
    case TriggerScenario.INTENSIVE_SCROLLING: {
      return <AppI18n k="brief_floating_form.popup.title.intensive_scrolling" />;
    }
    default: {
      return <AppI18n k="brief_floating_form.popup.title.manually" params={{ profession }} />;
    }
  }
};
